export default {
    nextStep(event) {
        event.preventDefault();

        if(this.$store.getters['results/getQuestionById'](this.showFieldsOn).value === null) {
            this.error = true;
            return;
        }

        event.currentTarget.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';

        this.$router.push({ path: '/onderzoek/' + this.recipient.hash + '/' + this.nextStepSlug });
    },
    showFields() {
        const question = this.$store.getters['results/getQuestionById'](this.showFieldsOn);

        return (question && question.value === 'ja');
    },
    previousStep(event) {
        event.currentTarget.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';

        this.$router.push({ path: '/onderzoek/' + this.recipient.hash + '/' + this.previousStepSlug });
    }
}
